import { ViewObjectContainerSaveableSettingsProvider } from "./view-object-container-saveable-settings-provider";

export class GridSaveableSettingsProvider extends ViewObjectContainerSaveableSettingsProvider {
  constructor(viewObjectProviders) {
    super(viewObjectProviders);
  }

  createSaveableSettings(settings) {
    if (settings.rows === undefined) {
      return {
        rows: []
      };
    }
    const parsedRows = [];
    for (let rowIndex = 0; rowIndex < settings.rows.length; rowIndex++) {
      const rowSettings = settings.rows[rowIndex];
      const rowInfo = {
        columns: []
      };
      for (let columnIndex = 0; columnIndex < rowSettings.columns.length; columnIndex++) {
        const itemSettings = this.createItemSettings(rowSettings.columns[columnIndex].item);
        rowInfo.columns.push({
          item: itemSettings
        });
      }
      parsedRows.push(rowInfo);
    }
    return {
      rows: parsedRows
    };
  }

  applySaveableSettings(settings, saveableSettings) {
    if (settings.rows === undefined || saveableSettings.rows === undefined || settings.rows.length != saveableSettings.rows.length) {
      return;
    }
    for (let rowIndex = 0; rowIndex < settings.rows.length; rowIndex++) {
      const rowSettings = settings.rows[rowIndex];
      const saveableRowSettings = saveableSettings.rows[rowIndex];
      if (
        rowSettings.columns !== undefined &&
        saveableRowSettings.columns !== undefined &&
        rowSettings.columns.length == saveableRowSettings.columns.length
      ) {
        for (let columnIndex = 0; columnIndex < rowSettings.columns.length; columnIndex++) {
          this.applyItemSettings(rowSettings.columns[columnIndex].item, saveableRowSettings.columns[columnIndex].item);
        }
      }
    }
  }
}
